/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EfsMelcoModelsCustomWarning
 */
export interface EfsMelcoModelsCustomWarning {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsCustomWarning
     */
    key?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsCustomWarning
     */
    source?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsCustomWarning
     */
    message?: string | null;
}

export function EfsMelcoModelsCustomWarningFromJSON(json: any): EfsMelcoModelsCustomWarning {
    return EfsMelcoModelsCustomWarningFromJSONTyped(json, false);
}

export function EfsMelcoModelsCustomWarningFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsCustomWarning {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function EfsMelcoModelsCustomWarningToJSON(value?: EfsMelcoModelsCustomWarning | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'source': value.source,
        'message': value.message,
    };
}


